<template>
    <div class="pantalla-menu">
        <div class="container-mob w-100 pb-0">

            <buscador-component></buscador-component>
            <div class="text-end mt-4">
                <a href="javascript: window.history.back()" class="color-red pe-3">
                    <i class="fas fa-chevron-left"></i>
                </a>
            </div>
            <div class="producto">
                <h3 class="mb-2">Tutorial</h3>
                <p>Descubre cómo funciona TarifApp con este sencillo tutorial. Así podrás acceder con rapidez a la información que necesitas sobre nuestros productos y crearás presupuestos personalizados para tus clientes de manera simple y cómoda.</p>
            </div>
            <div class="row">
                <video width="100%" height="auto" controls>
                    <source src="/assets/tutorial.mp4" type="video/mp4">
                </video>
            </div>
        </div>
        <menu-component></menu-component>
    </div>
</template>

<script>

export default {
    data() {
        return {
        };
    },
    methods: {
    },
    mounted: function () {
    }
};
</script>
